import FirstImg from "./CarouselPhotos/first.jpg";
import SecondImg from "./CarouselPhotos/second.jpg";
import ThirdImg from "./CarouselPhotos/third.jpg";
import FourthImg from "./CarouselPhotos/fourth.jpg";
import FifthImg from "./CarouselPhotos/fifth.jpg";
import SixthImg from "./CarouselPhotos/sixth.jpg";
import SeventhImg from "./CarouselPhotos/seventh.jpg";
import EighthImg from "./CarouselPhotos/eighth.jpg";
import NinthImg from "./CarouselPhotos/ninth.jpg";
import TenthImg from "./CarouselPhotos/tenth.jpg";
import EleventhImg from "./CarouselPhotos/eleventh.jpg";
import TwelfthImg from "./CarouselPhotos/twelfth.jpg";

export const images = [
  {
    src: FirstImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 20%", minWidth: "6%" }
  },
  {
    src: SecondImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 20%", minWidth: "6%" }
  },
  {
    src: ThirdImg,
    mobile: { backgroundPosition: "60% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 20%", minWidth: "6%" }
  },
  {
    src: FourthImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 40%", minWidth: "6%" }
  },
  {
    src: FifthImg,
    mobile: { backgroundPosition: "50% 15%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 15%", minWidth: "6%" }
  },
  {
    src: SixthImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 20%", minWidth: "6%" }
  },
  {
    src: SeventhImg,
    mobile: { backgroundPosition: "40% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 30%", minWidth: "6%" }
  },
  {
    src: EighthImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 30%", minWidth: "6%" }
  },
  {
    src: NinthImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 35%", minWidth: "6%" }
  },
  {
    src: TenthImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 12%", minWidth: "6%" }
  },
  {
    src: EleventhImg,
    mobile: { backgroundPosition: "80% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 15%", minWidth: "6%" }
  },
  {
    src: TwelfthImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 60%", minWidth: "6%" }
  }
];